<template>
  <div>
    <nav-header></nav-header>
    <div class="page-title p-l-50 p-r-50">
        <h2>Lista de Cobranças</h2>
        <hr />
    </div>
    <div class="input-container" v-if="this.isAdmin()">
      <dropdown-search
        :options="companies"
        placeholder="Selecione uma empresa"
        :disabled="false"
        v-on:selected="validateSelection"
        v-bind:searchFilter="this.getCompany()['name']"
      />
    </div>
    <div class="text-center mt-5">
      <b-spinner v-show="isLoading" label="Spinning"></b-spinner>
    </div>
    <b-table
      v-show="!isLoading"
      striped
      hover
      :items="charges"
      :fields="fields"
      show-empty
      :busy.sync="isBusy"
      empty-text="Não existe cobranças em aberto para este período!"
      class="mt-3"
    >
      <template v-if="!isBusy" #cell(actions)="row">
          <b-button
            :disabled="disabled(row.index)"
            size="sm"
            @click="info(row.index, $event.target)"
            class="my-1 btn-primary"
            v-b-tooltip.hover title="visualizar qr-code"
          >
            <b-icon-upc-scan font-scale=".8" style="vertical-align: text-top;" />
          </b-button>

          <b-button
            size="sm"
            @click="updateOneCharge(row.index)"
            class="my-1 mr-1 btn-primary"
            v-b-tooltip.hover title="atualizar status pagamento"
          >
            <b-icon-arrow-repeat font-scale=".8" style="vertical-align: text-top;" />
          </b-button>
      </template>
    </b-table>
    <b-modal :id="infoModal.id" ok-only>
       <template #modal-header>
          <div class="mx-auto">
            <h4>{{infoModal.title}}</h4>
          </div>
        </template>
        <h5 class="text-center">Data Cobrança: {{ infoModal.content.dataCob }}</h5>
        <qr-code class="qrcode mt-4" :text="infoModal.content.qrCode"></qr-code>
      <!-- <p>{{infoModal.content}}</p> -->
    </b-modal>
    <user-profile-footer></user-profile-footer>
  </div>
</template>

<style scoped src="@/assets/css/util.css" />

<style>

.qrcode > img{
  width: 70%;
  margin:auto;  
}
</style>

<style scoped>
.dropdown {
  width: 30%;
}
</style>

<script>
import axios from "axios";
import config from "../helpers/generalConfig";
import NavHeader from "../components/NavHeader.vue";
import Vue from "vue";
import VueQRCodeComponent from "vue-qrcode-component";
import UserProfileFooter from '../components/UserProfileFooter.vue';
import DropdownSearch from '../components/DropdownSearch.vue';
Vue.component("qr-code", VueQRCodeComponent);

export default {
  components: { NavHeader, UserProfileFooter, DropdownSearch },

  data() {
    return {
      isLoading: true,
      isBusy: true,
      fields: [
        {
          key: "cnpj_empresa",
          label: "CNPJ Empresa",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "nome_empresa",
          label: "Nome da Empresa",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "data_cobranca",
          label: "Data de Fechamento da Cobrança",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "custo_total",
          label: "Valor da Cobrança",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "status_cobranca",
          label: "Status da Cobrança",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "actions",
          label: "Pagamento",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      charges: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: {},
      },
      companies: [],
      company: '',
    };
  },
  mounted() {
    this.getAllCharges();
    this.getCompanies();
  },
  methods: {
    disabled(row) {
      return this.charges[row].qr_code === "";
    },
    info(item, button) {
      this.infoModal.title = "QR CODE";
      this.infoModal.content = {
        qrCode: this.charges[item].qr_code,
        dataCob: this.charges[item].data_cobranca,
      };
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    getAllCharges() {
      axios
        .get(`${config.jsonServer}/pix/charges?code=${this.company.id}`, this.headers())
        .then((res) => {
          this.charges = res.data.data;
          this.isBusy = false;
          this.isLoading = false;
        })
        .catch((err) => {
          this.$bvToast.toast(err.response.data.message, {
            title: "Erro na busca de cobranças",
            variant: "danger",
            solid: true,
          });
        });
    },
    
    headers() {
      const token = this.$store.getters["auth/token"].token;
      const headers = { headers: { Authorization: "Bearer " + token } };
      return headers;
      //const token = JSON.parse(localStorage.getItem('token')).token
      //const headers = { headers: { Authorization: 'Bearer ' + token }}
      //return headers;
    },
    isAdmin() {
      return this.$store.getters['auth/user'].Role == 'ADMIN_CEPE';
    },
    validateSelection(sel) {
      this.company = sel;
      this.isLoading = true;
      this.getAllCharges();
    },
    getCompany() {
      return {
        id: this.$store.getters['auth/user'].CompanyId,
        name: this.$store.getters['auth/user'].CompanyName,
      };
    },
    getCompanies() {
      axios
        .get(`${config.jsonServer}/company`, this.headers())
        .then((comps) => {
          this.companies = comps.data.map((c) => {
            return {
              id: c.id_empresa,
              name: c.nome_empresa,
            };
          });
        });
    },
    updateOneCharge(idx) {
     this.isLoading = true;
     const txId = this.charges[idx].tx_id;
     axios
        .post(`${config.jsonServer}/pix/paymentStatus`,
          {
            'tx_id':txId,
          },
          this.headers())
        .then((res) => {
          if(res.data.status === "CONCLUIDA"){
            this.charges[idx].status_cobranca = 'Cobrança paga';
            this.$bvToast.toast('A cobrança foi paga!', {
                                    title: 'Status da cobrança',
                                    variant: 'success',
                                    solid: true
                                });
          }else{
            this.$bvToast.toast('O status da cobrança ainda não foi atualizado!', {
                                    title: 'Status da cobrança',
                                    variant: 'warning',
                                    solid: true
                                });
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.$bvToast.toast("Falha na comunicação com a api", {
            title: "Erro na atualização da cobrança",
            variant: "danger",
            solid: true,
          });
        });
    },
  },
};
</script>